import service from "../service";

export default {
  //列表查询
  parameterSettingsListIndex(params: any, data: any): Promise<any> {
    return service({
      method: "POST",
      url: "/现场检测过程定义/列表查询",
      params,
      data: data
    });
  },
  //列表新增或更新
  parameterSettingsSave(data: any): Promise<any> {
    return service({
      method: "POST",
      url: "/现场检测过程定义/新增或更新检测项目",
      data: data
    });
  },
  //id查询
  parameterSettingsById(params: any): Promise<any> {
    return service({
      method: "GET",
      url: "/现场检测过程定义/ID查询",
      params
    });
  },
  //id删除
  parameterSettingsDelete(params: any): Promise<any> {
    return service({
      method: "DELETE",
      url: "/现场检测过程定义/ID删除",
      params
    });
  },
  // 现场检测过程定义 图片上传
  parameterSettingsUpload(data: any): Promise<any> {
    return service({
      method: "POST",
      url: "/现场检测过程定义/Upload",
      data
    });
  },
  // 现场检测过程定义 图片上传（带进度）
  parameterSettingsUploadWithProgress(data: any, onProgress?: (progress: number) => void): Promise<any> {
    return service({
      method: "POST",
      url: "/现场检测过程定义/Upload",
      data,
      onUploadProgress: (progressEvent: any) => {
        if (progressEvent.total && onProgress) {
          const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onProgress(progress);
        }
      }
    });
  },
  // 现场检测过程定义 图片下载
  parameterSettingsDownload(params: any): Promise<any> {
    return service({
      method: "GET",
      url: "/现场检测过程定义/Download",
      params,
      responseType: 'blob'
    });
  },
  // 现场检测过程定义 图片删除
  parameterSettingsDeleteImage(params: any): Promise<any> {
    return service({
      method: "DELETE",
      url: "/现场检测过程定义/Delete",
      params
    });
  },
  // 现场检测过程定义 设备类型查询
  parameterSettingsDeviceTypeList(params: any, data: any = []): Promise<any> {
    return service({
      method: "POST",
      url: "/现场检测过程定义/设备类型查询",
      params,
      data
    });
  },
 
  

  //经营项目定义
  operatingProjectListIndex(params: any, data: any): Promise<any> {
    return service({
      method: "POST",
      url: "/经营项目定义/列表查询",
      params,
      data: data
    });
  },
  //经营项目定义快速同步
  operatingProjectQuickSync(params: { key?: string }): Promise<any> {
    return service({
      method: "POST",
      url: "/经营项目定义/快速同步",
      params
    });
  },
  //经营项目定义新增或更新
  operatingProjectSave(data: any): Promise<any> {
    return service({
      method: "POST",
      url: "/经营项目定义/新增或更新经营项目",
      data: data
    });
  },
  //经营项目定义id查询
  operatingProjectById(params: any): Promise<any> {
    return service({
      method: "GET",
      url: "/经营项目定义/ID查询",
      params
    });
  },
  //经营项目定义id删除
  operatingProjectDelete(params: any): Promise<any> {
    return service({
      method: "DELETE",
      url: "/经营项目定义/ID删除",
      params
    });
  },
  // 经营项目图片上传
  operatingProjectUpload(data: any): Promise<any> {
    return service({
      method: "POST",
      url: "/经营项目定义/Upload",
      data
    });
  },
  // 经营项目图片上传（带进度）
  operatingProjectUploadWithProgress(data: any, onProgress?: (progress: number) => void): Promise<any> {
    return service({
      method: "POST",
      url: "/经营项目定义/Upload",
      data,
      onUploadProgress: (progressEvent: any) => {
        if (progressEvent.total && onProgress) {
          const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          onProgress(progress);
        }
      }
    });
  },
  // 经营项目图片下载
  operatingProjectDownload(params: any): Promise<any> {
    return service({
      method: "GET",
      url: "/经营项目定义/Download",
      params,
      responseType: 'blob'
    });
  },
  // 经营项目文件结构查询
  operatingProjectFileStructure(params: any): Promise<any> {
    return service({
      method: "GET",
      url: "/经营项目定义/查询项目文件结构",
      params
    });
  },
  // 经营项目文件下载
  operatingProjectFileDownload(params: any): Promise<any> {
    return service({
      method: "GET",
      url: "/经营项目定义/下载项目文件",
      params,
      responseType: 'blob'
    });
  },
  // 经营项目文件上传
  operatingProjectFileUpload(params: any, data: FormData): Promise<any> {
    return service({
      method: "POST",
      url: "/经营项目定义/上传项目文件",
      params,
      data
    });
  },
  // 经营项目文件删除
  operatingProjectFileDelete(params: any): Promise<any> {
    return service({
      method: "DELETE",
      url: "/经营项目定义/删除项目文件",
      params
    });
  },
  // 清空经营项目文件夹
  operatingProjectFileClear(params: any): Promise<any> {
    return service({
      method: "DELETE",
      url: "/经营项目定义/清空项目文件夹",
      params
    });
  },
  // 经营项目图片删除
  operatingProjectDeleteImage(params: any): Promise<any> {
    return service({
      method: "DELETE",
      url: "/经营项目定义/Delete",
      params
    });
  },
  // 客户端服务 图片下载
  clientDownload(params: any): Promise<any> {
    return service({
      method: "GET",
      url: "/客户端服务/客户端Download",
      params,
      responseType: 'blob'
    });
  },
  // 经营项目原始检测数据打印
  operatingProjectPrint(params: { id: number | string }): Promise<any> {
    return service({
      method: "GET",
      url: "/检测原始数据/经营项目原始检测数据打印",
      params
    });
  },
  // 检测原始数据设置人员
  setDetectionStaff(params: { 
    id: number | string; 
    检验人员: string; 
    校核人员: string; 
    计算人员: string 
  }): Promise<any> {
    return service({
      method: "POST",
      url: "/检测原始数据/设置人员",
      params
    });
  },
  //经营项目数据分析/列表查询
  analysisOfBusinessListIndex(params: any, data: any): Promise<any> {
    return service({
      method: "POST",
      url: "/经营项目数据分析/列表查询",
      params,
      data: data
    });
  },
  //经营项目数据分析/ID查询
  analysisOfBusinessById(params: any): Promise<any> {
    return service({
      method: "GET",
      url: "/经营项目数据分析/ID查询",
      params
    });
  },
  // 经营项目数据分析/经营数据分析详情
  analysisBusinessDetail(params: { id: number | string }): Promise<any> {
    // 后端参数：query string、字段名 Id、类型 integer(int64)
    return service({
      method: "POST",
      url: "/经营项目数据分析/经营数据分析详情",
      params: { Id: Number(params.id) }
    });
  },
  //经营项目数据分析/经营项目撤回
  analysisOfBusinessWithdraw(params: { id: number | string }): Promise<any> {
    return service({
      method: "POST",
      url: "/经营项目数据分析/经营项目撤回",
      params
    });
  },
  //经营项目数据分析/经营项目完成
  analysisOfBusinessComplete(params: { id: number | string }): Promise<any> {
    return service({
      method: "POST",
      url: "/经营项目数据分析/经营项目完成",
      params
    });
  },
  // 检测原始数据/所有原始数据汇总查询
  getAllRawDataSummary(params: { id: string }): Promise<any> {
    return service({
      method: "GET",
      url: "/检测原始数据/所有原始数据汇总查询",
      params
    });
  },
  // 经营项目数据分析/经营项目进度分析
  businessProgressAnalysis(params: any): Promise<any> {
    return service({
      method: "GET",
      url: "/经营项目数据分析/经营项目进度分析",
      params
    });
  },
    //检测项目包/列表查询
  detectionPackageListIndex(params: any, data: any): Promise<any> {
    return service({
      method: "POST",
      url: "/检测项目包/列表查询",
      params,
      data: data
    });
  },
  //检测项目包/新增或更新检测项目
  detectionPackageSave(data: any): Promise<any> {
    return service({
      method: "POST",
      url: "/检测项目包/新增或更新检测项目包",
      data: data
    });
  },
  //检测项目包/id查询
  detectionPackageById(params: any): Promise<any> {
    return service({
      method: "GET",
      url: "/检测项目包/ID查询",
      params
    });
  },
  //检测项目包/id删除
  detectionPackageDelete(params: any): Promise<any> {
    return service({
      method: "DELETE",
      url: "/检测项目包/ID删除",
      params
    });
  },

  // 房屋建筑定期体检过程定义/列表查询
  houseCheckListIndex(params: any, data: any): Promise<any> {
    return service({
      method: "POST",
      url: "/房屋建筑定期体检过程定义/列表查询",
      params,
      data: data
    });
  },
  // 房屋建筑定期体检过程定义/新增或更新房屋体检方案
  houseCheckSave(data: any): Promise<any> {
    return service({
      method: "POST",
      url: "/房屋建筑定期体检过程定义/新增或更新房屋体检方案",
      data: data
    });
  },
  // 房屋建筑定期体检过程定义/ID查询
  houseCheckById(params: any): Promise<any> {
    return service({
      method: "GET",
      url: "/房屋建筑定期体检过程定义/ID查询",
      params
    });
  },
  // 房屋建筑定期体检过程定义/ID删除
  houseCheckDelete(params: any): Promise<any> {
    return service({
      method: "DELETE",
      url: "/房屋建筑定期体检过程定义/ID删除",
      params
    });
  },

  // 房屋建筑定期体检项目定义/列表查询
  houseCheckPlanListIndex(params: any, data: any): Promise<any> {
    return service({
      method: "POST",
      url: "/房屋建筑定期体检项目定义/列表查询",
      params,
      data: data
    });
  },
  // 房屋建筑定期体检项目定义/新增或更新房屋体检项目
  houseCheckPlanSave(data: any): Promise<any> {
    return service({
      method: "POST",
      url: "/房屋建筑定期体检项目定义/新增或更新房屋体检项目",
      data: data
    });
  },
  // 房屋建筑定期体检项目定义/ID查询
  houseCheckPlanById(params: any): Promise<any> {
    return service({
      method: "GET",
      url: "/房屋建筑定期体检项目定义/ID查询",
      params
    });
  },
  // 房屋建筑定期体检项目定义/体检详细数据ID查询
  houseCheckPlanRecordDetailById(params: any): Promise<any> {
    return service({
      method: "GET",
      url: "/房屋建筑定期体检项目定义/体检详细数据ID查询",
      params
    });
  },
  // 房屋建筑定期体检项目定义/ID删除
  houseCheckPlanDelete(params: any): Promise<any> {
    return service({
      method: "DELETE",
      url: "/房屋建筑定期体检项目定义/ID删除",
      params
    });
  },
}
